// extracted by mini-css-extract-plugin
export default {"searchTerm":"SearchResultValue_searchTerm__Bl78s"};